import getLocalTrigger from "../../../utils/get-local-trigger";
import setWindowPointer from "../../../utils/set-window-pointer";
import run from "../../animate/run";

/**
 * Pointer or touch move
 * @param {CustomEventProps & PointerEvent} event
 */
const pointermove = (event) => {
  setWindowPointer(event);

  const triggers = /** @type {Map<MainClassProps, Array<String>>} */ (
    getLocalTrigger("pointer")
  );

  for (const [item, array] of triggers) {
    const main = item;

    for (const name of array) {
      const trigger = /** @type {TriggerProps} */ (main.store.get(name));
      const active = trigger.get("is-active");

      if (!active) {
        run(event, "enter", true, trigger, main);
      }
    }
  }
};

export default pointermove;
